import { cn } from "@gymflow/helpers";
import { Trans } from "react-i18next";
import { z } from "zod";

import { TabType } from "../../../../atoms";
import CashIcon from "../../../../atoms/icons/CashIcon";
import { CreditCard02Icon } from "../../../../atoms/icons/CreditCard02Icon";
import {
  CollectPastDueInvoiceFormValues,
  TabsCollectPastDueInvoiceType,
} from "./types";

export const TABS_COLLECT_PAST_DUE_INVOICE: TabType<TabsCollectPastDueInvoiceType>[] =
  [
    {
      id: "ONLINE",
      label: (isActive) => (
        <>
          <CreditCard02Icon
            className="size-7"
            pathClassName={cn("stroke-1", { "stroke-secondary-700": isActive })}
          />
          <Trans i18nKey="components.collectPastDueInvoiceSidebar.tabs.online" />
        </>
      ),
    },
    {
      id: "IN_PERSON",
      label: (isActive) => (
        <>
          <CashIcon
            className="size-7"
            pathClassName={cn({ "fill-secondary-700": isActive })}
          />
          <Trans i18nKey="components.collectPastDueInvoiceSidebar.tabs.inPerson" />
        </>
      ),
    },
  ];

export const INITIAL_VALUES_COLLECT_PAST_DUE_INVOICE_FORM: CollectPastDueInvoiceFormValues =
  {
    activeTabId: TABS_COLLECT_PAST_DUE_INVOICE[0].id,
    paymentMethodId: undefined,
    inPersonPaymentMethod: undefined,
  };

export const collectPastDueInvoiceFormSchema = z
  .object({
    activeTabId: z.enum(["ONLINE", "IN_PERSON"]),
    inPersonPaymentMethod: z
      .object({
        id: z.number(),
        label: z.string(),
        value: z.object({
          id: z.number(),
          name: z.string(),
        }),
      })
      .optional(),
    paymentMethodId: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.activeTabId === "IN_PERSON" && !data.inPersonPaymentMethod) {
      ctx.addIssue({
        path: ["inPersonPaymentMethod"],
        code: z.ZodIssueCode.custom,
        message: "This field is required",
      });
    }

    if (data.activeTabId === "ONLINE" && !data.paymentMethodId) {
      ctx.addIssue({
        path: ["paymentMethodId"],
        code: z.ZodIssueCode.custom,
        message: "Add payment method",
      });
    }
  });
